<template>
  <div id="vp-player" />
</template>

<script>
export default {
  name: 'VpPlayer',
  props: {
    filePath: {
      type: String,
      required: true,
    },
    playerId: {
      type: String,
      default: 'vp-player',
    },
    isLive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      vpPlayerLoaded: false,
    }
  },
  computed: {
    configsComputed() {
      return {
        video: {
          file: this.filePath,
          live: this.isLive,
        },
        config: {
          skin: {
            controlBar: {
              timeslider: {
                progress: '#1D79F2',
                buffer: '#FFFFFFB2',
                dragger: '#1D79F2',
                rail: '#FFFFFF80',
              },
            },
          },
        },
      }
    },
  },
  mounted() {
    if (window.vpPlayer) {
      this.initializePlayer()
    } else {
      this.configureVpPlayer()
    }
  },
  beforeDestroy() {
    this.destroyPlayers()
  },
  methods: {
    configureVpPlayer() {
      const script = document.createElement('script')
      script.src = 'https://host.vpplayer.tech/player/v2.0.5/vpplayer.js'
      script.async = true
      script.onload = () => {
        this.vpPlayerLoaded = true
        this.initializePlayer()
      }
      document.body.appendChild(script)
    },
    initializePlayer() {
      window.vpPlayer(this.playerId).setup(this.configsComputed)
      this.playerFilePath = this.filePath
    },
    destroyPlayers() {
      window.vpPlayer().destroy()
      this.playerFilePath = null
    },
  },
}
</script>
